<template>
  <div class="row" style="">
  <div class="container-fluid">
      <div id="loading-screen" v-show="isLoading">
        <div class="fancy-loader">
          <span>LOADING</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="lds-comets" width="250px" height="250px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(162.228 50 50)">
          <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;240 50 50;120 50 50;0 50 50" keyTimes="0;0.333;0.667;1" dur="1s" keySplines="0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1" calcMode="spline"/>
          <path fill="#41918E" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"/>
          <path fill="#E0E0E0" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"/>
          <path fill="#80CBC4" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"/></g>
          </svg>
        </div>
      </div>
    <!-- <router-link to="/central_analytics"> -->
     
      <div class="row">
        <div class="col-xs-4 col-md-12">
              <div data-intro='<b>Not Available on Help page</b><p>To play the tour guide, click on MSDAT platform and select the tour guide</p>'></div>
          <div v-tooltip.right="'Back to platform'" class="back-to-car-icon" @click="navigateToCentralAnalytics">
        <v-icon class="back-to-car-icon-v" style="color:white;">arrow_back</v-icon>
      </div>
        </div>
      </div>
    <!-- </router-link> -->
    
    <h1 class="help_subtitle ">Help</h1>
    <div class="_subtitle my-3 ">Help to Use the Multi-Source Data Analytics & Triangulation (MSDAT) Platform</div>
    <div class="text-center align-items-middle my-4" >
      <input class="search-box" type="text" v-model="searchKey" placeholder="Search Help by typing a keyword...">
    </div>
    <div class="info-box row my-4 ">
      <div class="col-md-2 col-sm-12 pr-0 pl-4" style="padding-left:50px !important" >
        <img class="img-responsive" alt="FAQ Icon" src="../../../../../static/img/faq.png"/>
      </div>
      <div class="pl-0  col-md-8  col-sm-12" >
        <strong>Got questions?</strong>
        <p style="font-size:15px;font-weight:bolder">See answers to some Frequently Asked Questions (FAQs) about the MSDAT Platform.</p>
      </div>
      <div class="col-md-2  col-sm-12" >
        <button class="btn text-light" style="border:none;width:110px !important">
         <a href='#faq' > See FAQs</a>
        </button>
      </div>
    </div>
    <div v-for="(i,index) in filterText" :key=index  >
      <div class="help-title" @click="i.show = !i.show">
        <span class="help-title-text">
          {{i.title}}
          <v-icon medium style="float:right;color:white;cursor:pointer;">{{i.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
        </span>
      </div>
      <div v-show="i.show" class="help-text">
        <div v-if="i.isArray === true">
          <!-- <p style="font-weight:bold;">{{i.title}}</p> -->
          <ul>

            <li class="helpList" v-for="(steps,count) in i.steps" :key="count" v-html="steps"></li>
          </ul>
        </div>
        <div v-else>
          <!-- <p style="font-weight:bold;">{{i.title}}</p> -->
          <div v-for="(key,counter) of i.steps" :key="counter">
            <p style="margin-top: 20px; font-weight: bold;">{{counter.replace('_',' ')}}</p>
            <ul>
              <li class="helpList" v-for="(steps,count) in key" :key="count">{{steps}}</li>
            </ul>
          </div>
        </div>
      </div>
      
    </div>
    <br>
    <br>

      <hr style="margin-top:-20px !important;">

    <br>
    <br>
    <h1 id="faq" class="faq_subtitle" style="margin-top:-40px !important">Frequently Asked Questions (FAQs)</h1>
    <div class="faq_sub ">Answers to some Frequently Asked Questions (FAQs) about MSDAT Platform.</div>
    <div v-for="(i,index) in faqArray" :key=index >
      <div class="help-title" @click="i.show = !i.show">
        <span class="help-title-text">
          {{i.title}}
          <v-icon medium style="float:right;color:white;cursor:pointer;">{{i.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
        </span>
      </div>
      <div v-show="i.show" class="help-text">
        
          <!-- <p style="font-weight:bold;">{{i.title}}</p> -->
          <ul>
            <li  class="helpList" v-html="i.ans"></li>
          </ul>
        
      </div>
      
    </div>
    </div>
    
  </div>
</template>


<script>
export default {
  data () {
    return {
      show: false,
      showBoolArray: [],
      iconIndex: '',
      searchKey: '',
      faqArray:[],
      filteredText: [],
      instructionArray: [],
      isLoading: false
    }
  },
  methods: {
    navigateToCentralAnalytics() {
      this.isLoading = true;
      setTimeout(() => {
        this.$router.push('central_analytics');
      }, 500);
    },
  },
  mounted(){
    this.faqArray = this.$store.state.CAR.faqs;
    this.instructionArray = this.$store.state.CAR.dashboardHelp;
    this.instructionArray.map((elem,index) => {
      if(Array.isArray(elem.steps)){
        elem.isArray = true;
      } else {
        elem.isArray = false;
      }
    });
    // console.log(this.instructionArray)
  },
  computed: {
    filterText(){
      return this.instructionArray.filter((item) => {
        return item.title.toLowerCase().includes(this.searchKey.toLowerCase());
      });
    },

  }
}
</script>
<style scoped>
  body{
    background:#F5F5F5;
  }

</style>



// WEBPACK FOOTER //
// car_help.vue?290292a6